import React from "react";
import { useStore } from "../../store/store";
import { calculatePanelWidth } from "../../util/formulas/calculatePanelWidth";
import { SelectChangeEvent } from "@mui/material/Select";

function findNumberOfPanels(config: string): number {
  const panels: string[] = config
    .split("OR")[0]
    .trim()
    .split("")
    .filter((item) => !isNaN(Number(item)));

  if (panels.length === 1) {
    return Number(panels[0]);
  }

  const numOfPanels: number = panels.reduce(
    (x: number, y: string) => Number(x) + Number(y),
    0
  );

  return numOfPanels;
}

function useSelection(
  selectedConfig: ((config: string) => void) | null,
  netWidth: number
) {
  const addToQuote = useStore((state) => state.addToQuote);

  const qty = useStore((state) => state.quote.quantity);

  const material = useStore((state) => state.quote.material);

  const isAlum = material === "All Aluminum"

  const qtyOptions = Array.from({ length: 20 }, (x, i) => i + 1);

  const handleChange = (event: SelectChangeEvent<string>) => {
    const { name, value } = event.target;

    let update = { [name as string]: value };

    if (name === "configuration") {
      selectedConfig && selectedConfig(value);
    } else {
      addToQuote(update);
    }
  };

  const isLargePanel = (config: string): string => {
    const numOfPanels = findNumberOfPanels(config);
    const panelWidth = calculatePanelWidth({
      doorType: "Bi-fold",
      netWidth,
      numberOfPanels: numOfPanels,
      material: isAlum ? "All Aluminum" : "Clad",
      exactConfig: config ? config.split("OR")[0].trim() : "",
      stilesAndRails: "",
    });

    if (panelWidth && panelWidth > 42) return `${config} (Wider Panels)`;
    return config;
  };

  return {
    qty,
    qtyOptions,
    handleChange,
    isLargePanel,
  };
}

export default useSelection;
